import {Component, OnInit} from '@angular/core';
import {ViewportScroller} from "@angular/common";

@Component({
  selector: 'btx-empty-order-summary',
  templateUrl: './empty-order-summary.component.html',
  styleUrls: ['./empty-order-summary.component.scss'],
  standalone: false
})
export class EmptyOrderSummaryComponent implements OnInit {

  constructor(private viewportScroller:ViewportScroller) { }

  ngOnInit(): void {
  }

  findTicket(){
    this.viewportScroller.scrollToAnchor("tickets");
  }

}
